import React from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import AnimationSection from "./AnimationSection";

const DownloadAnimationSection: React.FC = () => {
    const dispatch = useDispatch();

    const [hasDownloaded, setHasDownloaded] = React.useState(false);

    const executeDownloadFile = React.useCallback(() => {
        dispatch({
            type: "com.sage.actions.createAnimation.IDownloadVideoJobAnimation",
        } as sage.actions.createAnimation.IDownloadVideoJobAnimation);
        setHasDownloaded(true);
    }, [dispatch, setHasDownloaded]);

    const onNext = React.useCallback(() => {
        dispatch({
            type: "com.sage.actions.createAnimation.ISetTab",
            tab: 4,
        } as sage.actions.createAnimation.ISetTab);
    }, [dispatch]);

    return (
        <AnimationSection
            title="Download Result"
            description="Next, please download your animation file. You will use this file in the next step."
        >
            {hasDownloaded ? (
                <Button variant="secondary" onClick={onNext}>
                    Downloaded, Next Step
                </Button>
            ) : (
                <Button onClick={executeDownloadFile}>Download</Button>
            )}
        </AnimationSection>
    );
};

export default DownloadAnimationSection;
